import { useAuth } from '@/auth';
import { checkAnyPermissions, PERMISSIONS } from '@/auth/permissions';

/**
 * Hook para verificar permisos relacionados con cobros de otros trámites
 *
 * Nota: Actualmente usa permisos generales de trámites.
 * TODO: Cuando se agreguen permisos específicos para otros-tramites, actualizar este hook.
 */
export const useCobrosPermissions = () => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  // Por ahora usamos permisos generales de tramites
  // En el futuro se pueden agregar permisos específicos como:
  // - VIEW_OTROS_TRAMITES_COBROS
  // - CREATE_OTROS_TRAMITES_COBROS
  // - EDIT_OTROS_TRAMITES_COBROS
  // - DELETE_OTROS_TRAMITES_COBROS

  const canView = checkAnyPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canCreate = checkAnyPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canEdit = checkAnyPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canDelete = checkAnyPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  // Permisos combinados para operaciones específicas
  const canIniciarCobro = canCreate;
  const canRegistrarCobro = canCreate;
  const canEditarCobro = canEdit;
  const canEliminarCobro = canDelete;
  const canEditarMontoCobro = canEdit;
  const canEliminarCobros = canDelete;

  return {
    // Permisos base
    canView,
    canCreate,
    canEdit,
    canDelete,

    // Permisos específicos
    canIniciarCobro,
    canRegistrarCobro,
    canEditarCobro,
    canEliminarCobro,
    canEditarMontoCobro,
    canEliminarCobros,

    // Permisos combinados útiles
    canManageCobros: canCreate || canEdit || canDelete,
    hasAnyPermission: canView || canCreate || canEdit || canDelete,
  };
};
